<template>
  <div>
    <b-table
      id="treatmentTable"
      head-variant="light"
      hover
      small
      :busy="tableBusy"
      :items="items"
      :fields="fields"
      v-model="tableItems"
      @row-clicked="handleRowClicked"
      responsive
    >
      <template v-slot:cell(index)="row"> {{ row.index + 1 }}. </template>
      <template v-slot:cell(name)="row">
        {{ row.value }}
        <div v-if="row.item.anesthetic" class="aaci-badge aaci-badge-info">
          ยาชา: {{ anestheticText(row.item.anesthetic) }}
        </div>
        <div
          v-if="row.item.allergyAckDt || row.item.allergyConfirmed"
          class="aaci-badge aaci-badge-danger"
        >
          ยืนยันประวัติแพ้ยาแล้ว
        </div>
      </template>
      <template v-slot:cell(buttons)="data">
        <b-button
          v-if="mode !== 'edit'"
          class="show-when-hovered"
          size="xs"
          variant="outline-danger"
          @click="deleteItem(data.index, data.item)"
        >
          <i class="fas fa-trash-alt"></i>
        </b-button>
      </template>
      <template v-slot:cell(actionUid)="data">{{
        getUserListBy(data.item.actionUid, "uid").fullName
      }}</template>
      <template v-slot:cell(labId)="data">
        <b-form-select
          size="sm"
          v-model="data.item.labId"
          @change="$emit('labLinked', { item: data.item, labId: $event })"
        >
          <b-form-select-option :value="null">-</b-form-select-option>
          <b-form-select-option
            v-for="lab in incompleteLabs"
            :key="lab.id"
            :value="lab.id"
          >
            {{ lab.mLab?.nameTh || lab.mLab?.nameEn || '-' }}{{ lab.toothNo ? ` #${lab.toothNo}` : '' }}{{ lab.creationDt ? ` (${formatDate(lab.creationDt)})` : '' }}
          </b-form-select-option>
        </b-form-select>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>
    </b-table>
    <b-table
      v-if="overdueList.length > 0"
      class="small-text "
      table-variant="warning"
      small
      :items="overdueList"
      :fields="overdueFields"
      responsive
    >
      <template v-slot:cell(index)="row"> {{ row.index + 1 }}. </template>
      <template v-slot:cell(name)="row"
        ><div class="font-weight-bold">
          {{ formatDate(row.item.creationDt) }}
        </div>
        <div>
          {{ row.value }}
        </div>
      </template>
      <template #head(price)
        ><span>ราคา</span>
        <span class="text-danger">(ค้าง)</span>
      </template>
      <template v-slot:cell(price)="row">
        <div>{{ row.value | comma }}</div>
        <div class="text-danger">({{ overdueOf(row.item) | comma }})</div>
      </template>
      <template v-slot:cell(actionUid)="data">{{
        getUserListBy(data.item.actionUid, "uid").fullName
      }}</template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { eventBus } from "@/main";
import moment from "moment";
import { computeAnesthetic } from "@/utils/anesthetic";

import "@/theme/modal/PaymentHistory.scss";

export default {
  name: "SummaryTable",
  components: {},
  props: {
    items: { type: Array, default: () => [] },
    indexEdit: { type: Number, default: -1 },
    tableBusy: { type: Boolean, default: false },
    overdueList: { type: Array, default: () => [] },
    mode: { type: String, default: null },
    incompleteLabs: { type: Array, default: () => [] }
  },
  data() {
    return {
      tableItems: [],

      baseFields: [
        {
          key: "index",
          label: "",
        },
        {
          key: "name",
          label: "รายการวันนี้",
          sortable: false,
          class: "narrow-spacing",
        },
        {
          key: "price",
          label: "ราคา",
          sortable: false,
          class: "text-right narrow-spacing",
          formatter: this.$utils.formatPrice,
        },
        {
          key: "actionUid",
          label: "แพทย์",
          sortable: false,
          class: "narrow-spacing d-none d-lg-table-cell",
        },
        {
          key: "buttons",
          label: "",
          sortable: false,
        },
      ],
      overdueFields: [
        {
          key: "index",
          label: "",
        },
        {
          key: "name",
          label: "รายการค้างชำระ",
          sortable: false,
          class: "narrow-spacing",
        },
        // {
        //   key: "quantity",
        //   label: "จำนวน",
        //   sortable: false
        // },
        {
          key: "price",
          label: "ราคา(ค้าง)",
          sortable: false,
          class: "text-right narrow-spacing",
          formatter: this.$utils.formatPrice,
        },
        {
          key: "actionUid",
          label: "แพทย์",
          sortable: false,
          class: "narrow-spacing",
        },
      ],
    };
  },

  created() {
    this.init();
  },
  mounted() {},
  watch: {
    indexEdit(val) {
      if (val == -1) this.resetRowVariant();
    },
  },
  computed: {
    ...mapGetters({
      getDoctorList: "moduleUser/getDoctorList",
      getDoctorListBy: "moduleUser/getDoctorListBy",
      getUserInfo: "moduleUser/getUserInfo",
      getUserList: "moduleUser/getUserList",
      getUserListBy: "moduleUser/getUserListBy",
      isAccessMenu: "moduleUser/getIsAccessMenu",

      authorization: "moduleUser/getAuthorization",
      isDoctor: "moduleUser/isDoctor",

      getPatientOrthoPackageItemBy:
        "moduleTreatment/getPatientOrthoPackageItemBy",
    }),
    fields() {
      const result = [...this.baseFields];

      // Insert lab column before buttons if there are incomplete labs
      if (this.incompleteLabs.length > 0) {
        const buttonsIndex = result.findIndex(f => f.key === "buttons");
        result.splice(buttonsIndex, 0, {
          key: "labId",
          label: "เชื่อมแลป",
          sortable: false,
          class: "narrow-spacing d-none d-md-table-cell",
        });
      }

      return result;
    }
  },
  methods: {
    anestheticText(a) {
      let name = a.name;
      let totalMl = a.totalMl;
      let totalMg = a.totalMg;
      if (!name) {
        const m =
          this.$store.getters["moduleAppointment/getItemBy"](a.itemId, "id") ||
          {};
        name = m.nameTh || "";
        const r = computeAnesthetic({
          carpules: a.carpules,
          carpuleMl: m.carpuleMl,
          mgPerMl: m.mgPerMl,
        });
        totalMl = r.totalMl;
        totalMg = r.totalMg;
      }
      const parts = [name, `${a.carpules} carp`];
      if (totalMl !== null && totalMl !== undefined) parts.push(`${totalMl} ml`);
      if (totalMg !== null && totalMg !== undefined) parts.push(`${totalMg} mg`);
      return parts.join(" · ");
    },
    ...mapActions({
      fetchOrthoPackageUserList: "moduleTreatment/fetchOrthoPackageUserList",
      fetchTreatmentByApptId: "moduleTreatment/fetchTreatmentByApptId",
      updateStateOrthoPackageItem:
        "moduleTreatment/updateStateOrthoPackageItem",
    }),
    init() {},
    // Utils
    checkDoctorColumn() {
      var index = this.baseFields.findIndex(function (event) {
        return event.key == "actionUid";
      });
      if (index >= 0) {
        this.baseFields[index].thClass = "d-none";
        this.baseFields[index].tdClass = "d-none";
      } else {
        this.baseFields[index].thClass = "";
        this.baseFields[index].tdClass = "";
      }
    },
    getToothSurfacesPopover(toothSurfaces) {
      this.toothSurfaceList = [];
      if (toothSurfaces.length > 0) {
        toothSurfaces.forEach(res => {
          this.toothSurfaceList.push(this.getToothSurfaceBy(res, "id"));
        });
      }
    },
    hideToothSurfacesPopover() {
      this.$root.$emit("bv::hide::popover", "toothSurfacesPop");
    },
    vReset() {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.$v.$reset();
        });
      });
    },
    openProfileCustomerModal() {
      this.$parent.openProfileCustomerModal(
        this.appointment,
        this.patient,
        true //hide-footer
      );
    },
    deleteItem(index, data) {
      if (data.typeId == 2) {
        this.setUpdateOrthoPackageItem(data.orthoPackageItemId, false, null);
      }
      this.tableItems.splice(index, 1);
      this.$emit("update:items", this.tableItems);
      this.resetEditItem();
    },
    setUpdateOrthoPackageItem(id, status, balance) {
      let item = this.getPatientOrthoPackageItemBy(id, "id");
      if (!item) return;
      item.disabled = status;
      item.balance = balance;
      this.updateStateOrthoPackageItem(item);
    },
    handleRowClicked(row, index) {
      if (this.indexEdit === index) {
        this.resetEditItem();
        return;
      }
      this.resetRowVariant();
      this.tableItems[index]._rowVariant = "info";
      this.emitEditItem(row, index);
    },

    resetRowVariant() {
      this.tableItems.forEach(item => this.$set(item, "_rowVariant", ""));
    },
    resetEditItem() {
      this.resetRowVariant();
      this.resetIndexEdit();
    },
    resetIndexEdit() {
      this.$emit("update:indexEdit", -1);
    },
    emitEditItem(item, index) {
      this.$emit("editItem", item, index);
    },

    formatDate(date) {
      if (date) {
        return moment(date).locale("th").format("D MMM YY");
      } else {
        return "";
      }
    },
    overdueOf(item) {
      // Prefer BE-computed outstanding (= obligation − sumPaid across non-cancelled
      // receipts). Fall back to lastReceiptItem.overdue for old API responses
      // during deploy gap.
      return item?.outstanding ?? item?.lastReceiptItem?.overdue;
    },
  },
};
</script>

<style>
.aaci-badge {
  display: inline-block;
  font-size: 0.7rem;
  border-radius: 0.25rem;
  padding: 0 0.35rem;
  margin-top: 2px;
}
.aaci-badge-info {
  background: #e2eefe;
  color: #004085;
}
.aaci-badge-danger {
  background: #f8d7da;
  color: #721c24;
}
@keyframes highlightNew {
  0% {
    background-color: transparent;
    transform: scale(1);
  }
  50% {
    background-color: hsl(115, 80%, 82%);
    transform: scale(0.98);
  }
  100% {
    background-color: transparent;
    transform: scale(1);
  }
}

.highlight-new {
  animation: highlightNew 0.8s;
  overflow-x: hidden;
}
</style>